import axiosInstance from '@/plugins/axios';

export const STATUS_LABEL = {
  REGULAR: 'Regular',
  IRREGULAR: 'Irregular',
  INDISPONIVEL: 'Indisponível',
  COLETA_DESABILITADA: 'Coleta Desabilitada',
};

const ServiceCrf = {
  sincronizar: (cnpj) => axiosInstance.post('crf/sincronizar', { cnpj }),
  search: (body) => axiosInstance.post('crf/search', body),
  dashboard: () => axiosInstance.get('crf/dashboard'),
  salvar: (body) => axiosInstance.post('crf', body),
  atualizar: (id, body) => axiosInstance.put(`crf/${id}`, body),
  excluir: (id) => axiosInstance.delete(`crf/${id}`),
  historico: (id, body) => axiosInstance.post(`crf/${id}/historico`, body),
  // Export: enfileira um export persistido (report_process) — não retorna binário.
  exportData: (body) => axiosInstance.post('crf/export', body ?? {}),
  downloadUrl: (key) => axiosInstance.get(`storage/download-url?key=${encodeURIComponent(key)}`),
  uploadArquivo: (file, key) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('key', key);
    return axiosInstance.post('storage/upload', fd);
  },
};

export default ServiceCrf;
